// import { NewOAuthEmailIntegration } from './NewOAuthEmailIntegration';

// export const NewGoogleEmailIntegration = ({ onClose }) => {
//   return (
//     <NewOAuthEmailIntegration
//       onClose={onClose}
//       provider="Google"
//       apiEndpoint="gmail/auth-url"
//     />
//   );
// };

import { IconButton, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../global/theme/tokens';
import ExoForm from '../exo/ExoForm';
import { NewOAuthEmailIntegration } from './NewOAuthEmailIntegration';
import { API_DELETE, DBRequest, DBUploadData, useConfig } from '../../api/api';
import { useEffect, useState } from 'react';
import Feedback from '../special/Feedback';
import * as Yup from 'yup';
import DeleteIcon from '@mui/icons-material/Delete';
import ExoAlert from '../exo/ExoAlert';
import useFetch from '../../api/useFetch';

export const NewGoogleEmailIntegration = ({
  onChange,
  onDelete,
  userId,
  startData,
  onClose,
  debug,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();
  const config = useConfig();
  const [isLoading, setIsLoading] = useState(false);

  const [openAlert, setOpenAlert] = useState(
    startData?.integrationToken?.actionRequired,
  );

  const { apiData } = useFetch('gmail/auth-url');
  const url = apiData?.data?.authUrl;

  const fields = [
    {
      label: t('Color'),
      key: 'color',
      type: 'color',
      colspan: 3,
    },
    {
      label: t('Label'),
      key: 'label',
      type: 'text',
      colspan: 3,
    },
    {
      label: t('Add file'),
      key: 'file',
      type: 'directFileUpload',
      colspan: 3,
    },
  ];

  function handleSubmit(data) {
    const { file, label, color } = data;

    // Payload logic
    const payload = { file, label, color };

    DBUploadData({
      config,
      path: `email-credentials/${data.id}`,
      formData: payload,
      onResponse: (res) => {
        onClose();
        onChange(res.data.data);
      },
      onFeedback: handleFeedback,
      onLoading: setIsLoading,
    });
  }

  // feedback
  const [alertState, setAlertState] = useState({
    alertOpen: false,
    alertType: 'info',
    alertText: 'test',
  });
  function handleFeedback(text, type) {
    setAlertState({ alertOpen: true, alertText: text, alertType: type });
  }

  const validationSchema = Yup.object().shape({
    color: Yup.string().required(t('Is required')),
    label: Yup.string().required(t('Is required')),
  });

  const defaultData = {
    color: '#339e87',
  };

  function handleDelete() {
    // Handle delete logic here
    DBRequest({
      config,
      path: `email-credentials/${startData.id}`,
      method: API_DELETE(),
      onResponse: () => {
        onDelete(startData);
        onClose();
      },
      onLoading: setIsLoading,
    });
  }

  const [defaultStartData, setDefaultStartData] = useState(defaultData);
  useEffect(() => {
    if (startData) setDefaultStartData(startData);
  }, [startData]);

  if (!startData) {
    return (
      <NewOAuthEmailIntegration
        onClose={onClose}
        provider="Google"
        apiEndpoint="gmail/auth-url"
      />
    );
  }

  return (
    <>
      {startData && startData.id && (
        <IconButton
          onClick={handleDelete}
          sx={{ position: 'absolute', marginTop: 2.5 }}
          className="right-2 z-10"
          color="error"
        >
          <DeleteIcon />
        </IconButton>
      )}

      <ExoForm
        debug={debug}
        header={t('Edit Gmail Account')}
        className="grid grid-cols-3 gap-4"
        fields={fields}
        onSubmit={handleSubmit}
        startDataCollection={defaultStartData}
        size="small"
        validationSchema={validationSchema}
        noAutoReset
        noDifferences
        onCancel={onClose}
        isLoading={isLoading}
      />
      {/* Account Verification Alert */}
      <ExoAlert
        open={Boolean(openAlert)}
        onSubmit={() => window.open(url)}
        onClose={() => {
          setOpenAlert(false);
        }}
        alert={{
          type: 'warning',
          message: t(
            'Your Gmail connection requires re-verification to continue syncing. Please verify your account.',
          ),
          cancelLabel: t('Close'),
          submitLabel: t('Re-verify now'),
        }}
      />
      <Feedback state={alertState} setState={setAlertState} />
    </>
  );
};
